export default "/images/0b27f3154cc74f07d144afa67a53a16f.avif";